export const Types = {
    SET_CONFIGS: "SET_CONFIGS",
  };
  
export const setConfigs = configs => ({
    type: Types.SET_CONFIGS,
    payload: configs,
  });